import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-upload-gst',
  templateUrl: './upload-gst.component.html',
  styleUrls: ['./upload-gst.component.scss']
})
export class UploadGstComponent implements OnInit {

  financialYearList: any = [
    {
      name: 'Select Financial Year',
    },
    {
      name: '2022-23',
      value: '2022-23'
    },
    {
      name: '2023-24',
      value: '2023-24'
    },
    {
      name: '2024-25',
      value: '2024-25'
    },
    {
      name: '2025-26',
      value: '2025-26'
    }
  ]

  isSubmitted: boolean = false;
  gstDeatilsForm: FormGroup;
  fileType: any;
  uploadFileUrl: any;
  userId: any;
  vendorCode: any;

  ipAddress: any = '000.000.000';

  constructor(
    private fb: FormBuilder,
    private _personalDetalSer: FarmersDetailsService,
    private messageService: MessageService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private vendorDashboardService: VendorDashboardService,
    private ipService: IpAddressService,
  ) { }

  ngOnInit(): void {
    this.getIP();
    const token: any = JSON.parse(sessionStorage.getItem('token'));
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.activityRecordService.activityRecord(this.userId, 'GST Details', '', new Date(), 'Success');

    this.vendorCode = sessionStorage.getItem('officeCode')
    this.gstDeatilsForm = this.fb.group({  
      financialYear: ['', Validators.required],
      gstCertificatePath: ['', Validators.required],
      remarks: ['', Validators.required],
    })
  }

  get f() {
    return this.gstDeatilsForm.controls;
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    if (file.name.includes('.pdf')) {
      this.fileType = 'PDF'
    } else {
      this.fileType = 'IMAGE'
    }
    let data = new FormData();
    data.append('file', file);
    let phNo = sessionStorage.getItem('farmerPh');
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      if (resp.data) {
        this.uploadFileUrl = resp.data
        this.gstDeatilsForm.patchValue({ [formcontrol]: resp.data });
      }
      if (resp.statusCode == 200) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File Uploaded with Auto Mode',
        });
      }
    });
    uploadElement.clear();
  }

  submitUploadGSTDetails(){
    this.isSubmitted = true;
    console.log(this.gstDeatilsForm.value, this.gstDeatilsForm.valid)
    if(this.gstDeatilsForm.valid){

      let val = this.gstDeatilsForm.value;
      let reqBody = {
        finYear: val?.financialYear,
        gstCertificatePath: val?.gstCertificatePath,
        remarks: val?.remarks,
        vendorCode: this.vendorCode,
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress
      }


      this.loader.start();
      this.vendorDashboardService
        .insertUploadedGSTDetail(reqBody)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.loader.close();

            this.activityRecordService.activityRecord(this.userId, 'GST Details Submit', '', new Date(), 'Success');
            if(data == "Record saved Successfully"){
              this.messageService.add({
                severity: 'success',
                summary: 'Status',
                detail: data,
              });

              this.isSubmitted = false;
              this.gstDeatilsForm.reset();
            }
            else{
              this.messageService.add({
                severity: 'info',
                summary: 'Status',
                detail: data,
              });
            }
          },
          error: (err) => {
            this.loader.close();
            this.activityRecordService.activityRecord(this.userId, 'GST Details Submit', '', new Date(), err);
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          },
        });
    }
    else{
      return;
    }
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
}
